// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file travplaces/v1/city.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_travplaces_v1_audit } from "./audit_pb";
import { file_travplaces_v1_authz } from "./authz_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file travplaces/v1/city.proto.
 */
export const file_travplaces_v1_city: GenFile = /*@__PURE__*/
  fileDesc("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", [file_travplaces_v1_audit, file_travplaces_v1_authz, file_google_protobuf_timestamp]);

/**
 * City is a supported destination with a bounding box + centre.
 *
 * @generated from message travplaces.v1.City
 */
export type City = Message<"travplaces.v1.City"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: string country_code = 4;
   */
  countryCode: string;

  /**
   * @generated from field: string timezone = 5;
   */
  timezone: string;

  /**
   * "imperial" | "metric"
   *
   * @generated from field: string units = 6;
   */
  units: string;

  /**
   * @generated from field: double center_lat = 7;
   */
  centerLat: number;

  /**
   * @generated from field: double center_lng = 8;
   */
  centerLng: number;

  /**
   * @generated from field: double bbox_min_lat = 9;
   */
  bboxMinLat: number;

  /**
   * @generated from field: double bbox_min_lng = 10;
   */
  bboxMinLng: number;

  /**
   * @generated from field: double bbox_max_lat = 11;
   */
  bboxMaxLat: number;

  /**
   * @generated from field: double bbox_max_lng = 12;
   */
  bboxMaxLng: number;

  /**
   * draft | importing | ready | error
   *
   * @generated from field: string status = 13;
   */
  status: string;

  /**
   * @generated from field: int32 default_avoid_distance_m = 14;
   */
  defaultAvoidDistanceM: number;

  /**
   * @generated from field: int32 poi_count = 15;
   */
  poiCount: number;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 16;
   */
  createdAt?: Timestamp | undefined;

  /**
   * What the build pipeline has actually produced for this city, as opposed
   * to which steps were clicked. Derived from the files on disk each time the
   * city is read, so a city whose data was cleared out reports the truth
   * rather than a stale flag, and the admin stepper can mark the steps that
   * are genuinely done.
   *
   * the .osm.pbf has been downloaded
   *
   * @generated from field: bool has_extract = 17;
   */
  hasExtract: boolean;

  /**
   * Valhalla tiles have been built
   *
   * @generated from field: bool has_routing_tiles = 18;
   */
  hasRoutingTiles: boolean;

  /**
   * a vector basemap archive exists
   *
   * @generated from field: bool has_basemap = 19;
   */
  hasBasemap: boolean;
};

/**
 * Describes the message travplaces.v1.City.
 * Use `create(CitySchema)` to create a new message.
 */
export const CitySchema: GenMessage<City> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_city, 0);

/**
 * @generated from message travplaces.v1.ListCitiesRequest
 */
export type ListCitiesRequest = Message<"travplaces.v1.ListCitiesRequest"> & {
};

/**
 * Describes the message travplaces.v1.ListCitiesRequest.
 * Use `create(ListCitiesRequestSchema)` to create a new message.
 */
export const ListCitiesRequestSchema: GenMessage<ListCitiesRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_city, 1);

/**
 * @generated from message travplaces.v1.ListCitiesResponse
 */
export type ListCitiesResponse = Message<"travplaces.v1.ListCitiesResponse"> & {
  /**
   * @generated from field: repeated travplaces.v1.City cities = 1;
   */
  cities: City[];
};

/**
 * Describes the message travplaces.v1.ListCitiesResponse.
 * Use `create(ListCitiesResponseSchema)` to create a new message.
 */
export const ListCitiesResponseSchema: GenMessage<ListCitiesResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_city, 2);

/**
 * @generated from message travplaces.v1.GetCityRequest
 */
export type GetCityRequest = Message<"travplaces.v1.GetCityRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.GetCityRequest.
 * Use `create(GetCityRequestSchema)` to create a new message.
 */
export const GetCityRequestSchema: GenMessage<GetCityRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_city, 3);

/**
 * @generated from message travplaces.v1.GetCityResponse
 */
export type GetCityResponse = Message<"travplaces.v1.GetCityResponse"> & {
  /**
   * @generated from field: travplaces.v1.City city = 1;
   */
  city?: City | undefined;
};

/**
 * Describes the message travplaces.v1.GetCityResponse.
 * Use `create(GetCityResponseSchema)` to create a new message.
 */
export const GetCityResponseSchema: GenMessage<GetCityResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_city, 4);

/**
 * @generated from message travplaces.v1.CreateCityRequest
 */
export type CreateCityRequest = Message<"travplaces.v1.CreateCityRequest"> & {
  /**
   * @generated from field: string slug = 1;
   */
  slug: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * defaults to "US" when empty
   *
   * @generated from field: string country_code = 3;
   */
  countryCode: string;

  /**
   * @generated from field: string timezone = 4;
   */
  timezone: string;

  /**
   * defaults to "imperial" when empty
   *
   * @generated from field: string units = 5;
   */
  units: string;

  /**
   * @generated from field: double center_lat = 6;
   */
  centerLat: number;

  /**
   * @generated from field: double center_lng = 7;
   */
  centerLng: number;

  /**
   * @generated from field: double bbox_min_lat = 8;
   */
  bboxMinLat: number;

  /**
   * @generated from field: double bbox_min_lng = 9;
   */
  bboxMinLng: number;

  /**
   * @generated from field: double bbox_max_lat = 10;
   */
  bboxMaxLat: number;

  /**
   * @generated from field: double bbox_max_lng = 11;
   */
  bboxMaxLng: number;
};

/**
 * Describes the message travplaces.v1.CreateCityRequest.
 * Use `create(CreateCityRequestSchema)` to create a new message.
 */
export const CreateCityRequestSchema: GenMessage<CreateCityRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_city, 5);

/**
 * @generated from message travplaces.v1.CreateCityResponse
 */
export type CreateCityResponse = Message<"travplaces.v1.CreateCityResponse"> & {
  /**
   * @generated from field: travplaces.v1.City city = 1;
   */
  city?: City | undefined;
};

/**
 * Describes the message travplaces.v1.CreateCityResponse.
 * Use `create(CreateCityResponseSchema)` to create a new message.
 */
export const CreateCityResponseSchema: GenMessage<CreateCityResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_city, 6);

/**
 * @generated from message travplaces.v1.DeleteCityRequest
 */
export type DeleteCityRequest = Message<"travplaces.v1.DeleteCityRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message travplaces.v1.DeleteCityRequest.
 * Use `create(DeleteCityRequestSchema)` to create a new message.
 */
export const DeleteCityRequestSchema: GenMessage<DeleteCityRequest> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_city, 7);

/**
 * @generated from message travplaces.v1.DeleteCityResponse
 */
export type DeleteCityResponse = Message<"travplaces.v1.DeleteCityResponse"> & {
};

/**
 * Describes the message travplaces.v1.DeleteCityResponse.
 * Use `create(DeleteCityResponseSchema)` to create a new message.
 */
export const DeleteCityResponseSchema: GenMessage<DeleteCityResponse> = /*@__PURE__*/
  messageDesc(file_travplaces_v1_city, 8);

/**
 * CityService manages the destination catalogue.
 *
 * @generated from service travplaces.v1.CityService
 */
export const CityService: GenService<{
  /**
   * ListCities returns every city, alphabetical.
   *
   * @generated from rpc travplaces.v1.CityService.ListCities
   */
  listCities: {
    methodKind: "unary";
    input: typeof ListCitiesRequestSchema;
    output: typeof ListCitiesResponseSchema;
  },
  /**
   * GetCity returns one city by id.
   *
   * @generated from rpc travplaces.v1.CityService.GetCity
   */
  getCity: {
    methodKind: "unary";
    input: typeof GetCityRequestSchema;
    output: typeof GetCityResponseSchema;
  },
  /**
   * CreateCity adds a city (bbox + centre required).
   *
   * @generated from rpc travplaces.v1.CityService.CreateCity
   */
  createCity: {
    methodKind: "unary";
    input: typeof CreateCityRequestSchema;
    output: typeof CreateCityResponseSchema;
  },
  /**
   * DeleteCity removes a city and its POIs (cascade).
   *
   * @generated from rpc travplaces.v1.CityService.DeleteCity
   */
  deleteCity: {
    methodKind: "unary";
    input: typeof DeleteCityRequestSchema;
    output: typeof DeleteCityResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_travplaces_v1_city, 0);

